var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 22,
    viewBox: "0 0 34 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.10884 10.7885L10.1919 15.0755C10.3448 15.2251 10.4661 15.4041 10.5484 15.6016C10.6308 15.7992 10.6724 16.0113 10.671 16.2254C10.6696 16.4394 10.625 16.6509 10.5401 16.8474C10.4551 17.0438 10.3314 17.2211 10.1764 17.3687C10.0215 17.5163 9.83834 17.6312 9.638 17.7065C9.43765 17.7818 9.22419 17.816 9.01036 17.807C8.79652 17.798 8.58668 17.746 8.39336 17.6542C8.20004 17.5623 8.0272 17.4325 7.88516 17.2724L1.14921 10.2L0.0507272 9.0466L1.20408 7.94812L8.27653 1.21217C8.58542 0.938097 8.98864 0.794616 9.40123 0.811958C9.81382 0.829299 10.2036 1.00611 10.4884 1.30514C10.7732 1.60417 10.9308 2.00207 10.928 2.41502C10.9252 2.82796 10.7623 3.22371 10.4735 3.51888L6.18649 7.6019L27.1753 8.11338C29.0064 8.15801 30.7448 8.92821 32.008 10.2545C33.2712 11.5809 33.9558 13.3547 33.9112 15.1858C33.8666 17.0169 33.0964 18.7553 31.77 20.0186C30.4437 21.2818 28.6699 21.9664 26.8388 21.9218L22.59 21.8182C22.1675 21.8079 21.7663 21.6302 21.4748 21.3241C21.1833 21.0181 21.0253 20.6087 21.0356 20.1861C21.0459 19.7636 21.2236 19.3624 21.5297 19.0709C21.8358 18.7794 22.2451 18.6214 22.6677 18.6317L26.9164 18.7352C27.9024 18.7593 28.8575 18.3906 29.5717 17.7104C30.2859 17.0302 30.7006 16.0942 30.7247 15.1082C30.7487 14.1222 30.3801 13.1671 29.6998 12.4529C29.0196 11.7387 28.0836 11.324 27.0976 11.2999L6.10884 10.7885Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.9663de7573710e6772043721b010d899.svg";
export { ForwardRef as ReactComponent };